import {
  GET_APPOINTMENTS_SUCCESS,
  GET_APPOINTMENTS_FAIL,
  GET_APPOINTMENTS_DETAILS_SUCCESS,
  GET_APPOINTMENTS_DETAILS_FAIL,
  ADD_APPOINTMENTS_SUCCESS,
  ADD_APPOINTMENTS_FAIL,
  UPDATE_APPOINTMENTS_SUCCESS,
  UPDATE_APPOINTMENTS_FAIL,
  DELETE_APPOINTMENTS_SUCCESS,
  DELETE_APPOINTMENTS_FAIL,
  CONFIRM_APPOINTMENTS_SUCCESS,
  CONFIRM_APPOINTMENTS_FAIL,
  ADD_REMARKS_APPOINTMENTS_SUCCESS,
  ADD_REMARKS_APPOINTMENTS_FAIL,
  RESET_APPOINTMENTS_STATE,
} from "./actionTypes"

const INIT_STATE = {
  appointments: [],
  appointmentsDetails: [],
  addAppointments: [],
  editAppointments: [],
  delAppointments: [],
  confirmAppointments: [],
  addRemarksAppointment: [],
}

const Appointments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointments: action.payload,
      }

    case GET_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_APPOINTMENTS_DETAILS_SUCCESS:
      return {
        ...state,
        appointmentsDetails: action.payload,
      }

    case GET_APPOINTMENTS_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
        appointmentsDetails: action.payload,
      }

    case ADD_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointmentsDetails: action.payload.data,
        addAppointments: action.payload,
      }

    case ADD_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointmentsDetails: action.payload.data,
        editAppointments: action.payload,
      }

    case UPDATE_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        editAppointments: action.payload,
      }
    case DELETE_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        delAppointments: action.payload,
      }

    case DELETE_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case CONFIRM_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        confirmAppointments: action.payload,
      }

    case CONFIRM_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        confirmAppointments: action.payload,
      }
    case ADD_REMARKS_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        addRemarksAppointment: action.payload,
      }

    case ADD_REMARKS_APPOINTMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        addRemarksAppointment: action.payload,
      }
    case RESET_APPOINTMENTS_STATE:
      return {
        ...state,
        addAppointments: [],
        editAppointments: [],
        delAppointments: [],
        confirmAppointments: [],
        addRemarksAppointment: [],
        appointmentsDetails: [],
        error: [],
      }
    default:
      return state
  }
}

export default Appointments
